module.exports = __webpack_public_path__ + "static/seo-24abde052faa4f65a26f8eafa55cf29f.svg";